module.exports = "query VoucherTypes{voucherTypes{value text}}"